const pickupColumns = (setPickupData, pickupData, selectedDriver, drivers) => {
    return ([
      {
        name: ' ',
        width: '50px',
        cell: (row, index, column, id) => {
          return <input style={{ width: '25px', height: '25px' }} type="checkbox" value={`checkbox_${row.returnAuthId}`} checked={row.driver === selectedDriver.email ? true : false} disabled={row.completed || (row.driver && row.driver !== selectedDriver.email)} onChange={(e) => {
            setPickupData(row, e.target.checked);
          }} />
        }
      },
      {
        name: 'RA #',
        width: '180px',
        selector: row => { return row.returnAuthId }
      },
      {
        name: 'Order(s)',
        width: '180px',
        selector: row => row.orders.map(o => o.id).join(', '),
      },
      {
        name: 'Customer',
        width: '150px',
        selector: row => `${row.customer.firstName}, ${row.customer.lastName}`
      },
      {
        name: 'Company',
        selector: row => row.customer.company
      },
      {
        name: 'Address',
        wrap: true,
        selector: row => `${row.address.address1} ${row.address.address2 ? row.address.address2 : ''} ${row.address.city}, ${row.address.state} ${row.address.zip}`,
        format: row => {
          let address = `${row.address.address1} ${row.address.address2 ? row.address.address2 : ''} ${row.address.city}, ${row.address.state} ${row.address.zip}`;
          return <span title={address}>{address}</span>
        }
      },
      {
        name: 'Status',
        selector: row => {
          if (row.completed) {
            return 'Completed';
          }
          else if (row.driver && row.driver === selectedDriver.email) {
            return `Assigned`
          }
          else if (row.driver && row.driver !== selectedDriver.email) {
            let driver = drivers.find(d => d.email === row.driver);
            return `Assigned (${driver.label})`;
          }
          else {
            return 'Open';
          }
        }
      },
      {
      name: 'Pickup Time',
      selector: row => row.pickupTime,
      format: row =>{
        if(row.deliveryTime)
        {
          let time = row.pickupTime.substring(row.pickupTime.indexOf('T')+1, row.pickupTime.lastIndexOf('.'));
          return <span title={time}>{time}</span>;
        }
        else
        {
          return '';
        }
      }
    }
  
    ]);
}
export default pickupColumns;